// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"307":"26898217","635":"e350d087","878":"a927d816","927":"a0c74ad6"}[chunkId] + ".chunk.js";
};